import { render, staticRenderFns } from "./RewardNum.vue?vue&type=template&id=13167341&"
import script from "./RewardNum.vue?vue&type=script&lang=js&"
export * from "./RewardNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports